<!--
  Modal de vista previa. Úsalo así desde cualquier componente que imprima:

    <TicketPreview ref="preview" />

  Y donde antes llamabas directo a fetch('/print', ...), primero muestra la
  vista previa y deja que el botón del modal decida si imprime:

    this.$refs.preview.mostrar(payload)   // payload = el mismo JSON de siempre

  El componente pide /preview al agente local, muestra el texto exacto que
  va a salir impreso, y si el usuario confirma, manda /print con ese mismo
  payload.
-->
<template>
  <modal name="ticketPreview" :adaptive="true" :scrollable="true" height="auto" width="360">
    <div class="text-right p-2">
      <span class="close-modal" @click="$modal.hide('ticketPreview')">
        <font-awesome-icon :icon="['fa', 'times-circle']" />
      </span>
    </div>
    <div class="preview-wrapper">
      <pre class="preview-receipt">{{ previewText }}</pre>
    </div>
    <div class="preview-actions">
      <button class="btn btn-secondary" @click="$modal.hide('ticketPreview')">Cancelar</button>
      <button class="btn btn-orange" :disabled="imprimiendo" @click="confirmarImpresion">
        {{ imprimiendo ? 'Imprimiendo...' : 'Imprimir' }}
      </button>
    </div>
  </modal>
</template>

<script>
const PRINT_AGENT_URL = 'http://127.0.0.1:39120'

export default {
  data () {
    return {
      previewText: '',
      payloadActual: null,
      imprimiendo: false
    }
  },
  methods: {
    async mostrar (payload) {
      this.payloadActual = payload
      this.previewText = 'Cargando vista previa...'
      this.$modal.show('ticketPreview')

      try {
        const resp = await fetch(`${PRINT_AGENT_URL}/preview`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        const data = await resp.json()
        this.previewText = data.ok
          ? data.preview
          : 'No se pudo generar la vista previa: ' + data.error
      } catch (e) {
        this.previewText =
          'No se pudo conectar con el agente de impresión local.\nVerifica que esté abierto en esta computadora.'
      }
    },

    async confirmarImpresion () {
      this.imprimiendo = true
      try {
        const resp = await fetch(`${PRINT_AGENT_URL}/print`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.payloadActual)
        })
        const data = await resp.json()
        if (data.ok) {
          this.$modal.hide('ticketPreview')
        } else {
          this.showError('Error al imprimir: ' + data.error)
        }
      } catch (e) {
        this.showError('No se pudo conectar con el agente de impresión local.')
      } finally {
        this.imprimiendo = false
      }
    }
  }
}
</script>

<style scoped>
.preview-wrapper {
  display: flex;
  justify-content: center;
  padding: 0 12px 12px;
}
.preview-receipt {
  background: #fff;
  color: #111;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  line-height: 1.4;
  padding: 16px;
  width: 300px;
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid #ddd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  white-space: pre-wrap;
  word-break: break-word;
}
.preview-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 0 12px 16px;
}
</style>
